import ListIcon from "../images/ListIcon.mjs";

/**
 * App icon for perimeters list and management
 * @see {GlyphIcon}
 * @see {ListIcon}
 */
const AppGestionePerimetriIcon = class extends ListIcon {}

export default AppGestionePerimetriIcon;